var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderTokenCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0333 6C6.87862 6 2.69995 8.26667 2.69995 10V14C2.69995 15.7333 6.87862 18 12.0333 18C17.188 18 21.3666 15.7333 21.3666 14V10C21.3666 8.26667 17.188 6 12.0333 6ZM12.0333 6C17.188 6 21.3666 8.15733 21.3666 9.99733C21.3666 11.8373 17.188 13.9787 12.0333 13.9787C6.87862 13.9787 2.69995 11.8373 2.69995 9.99733C2.69995 8.156 6.87862 6 12.0333 6Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderTokenCoin);
export default __webpack_public_path__ + "static/media/header-token-coin.0aaed3bb9685191feb2c44331d798eb9.svg";
export { ForwardRef as ReactComponent };